export const mainGoldFont = {
  dropShadow: true,
  dropShadowAlpha: 0.4,
  dropShadowAngle: 1.6,
  dropShadowColor: "#191900",
  dropShadowDistance: 6,
  fill: [
    "#ffac00",
    "#feff4c"
  ],
  fillGradientStops: [
    0.3,
    0.6,
    0.5
  ],
  lineJoin: "round",
  miterLimit: 0,
  stroke: "#610000",
  strokeThickness: 8,
};

export const freespinsPopupsFont = {
  dropShadow: true,
  dropShadowColor: "#191900",
  dropShadowAlpha: 0.6,
  dropShadowAngle: 1.6,
  dropShadowDistance: 8,
  fill: [
    "#ffbf00",
    "#ffe400",
    "#ff6100"
  ],
  fillGradientStops: [
    0.3,
    0.5,
    0.7
  ],
  lineJoin: "round",
  miterLimit: 0,
  stroke: "#860000",
  strokeThickness: 10,
  letterSpacing: -4,
};

export const jackpotValues = {
  stroke: "#790000",
  strokeThickness: 8,
  fill: 'white',
  lineJoin: 'round',
  miterLimit: 0,
};

export const bonusLabels = {
  ...jackpotValues,
  fontSize: 50,
  fillGradientStops: [],
};

export const jackpotLabels = {
  fill: [
    "#ffb000",
    "#fffb48"
  ],
  fillGradientStops: [
    0.4
  ],
  fontSize: 60,
  lineJoin: "round",
  miterLimit: 0,
  stroke: "#560000",
  strokeThickness: 8,
  whiteSpace: "normal"
};
